<template>
  <div v-if="modelType" class="channel-tag" :class="modelType"></div>
  <div v-else></div>
</template>

<script>
export default {
  name: 'PartnerChannelTag',
  props: {
    model: {
      type: String,
      default: function () {
        return ''
      }
    }
  },
  computed: {
    modelType() {
      return this.model
    }
  },
  data() {
    return {}
  },

  mounted() {},

  methods: {}
}
</script>

<style lang="less" scoped>
.channel-tag {
  width: 44px;
  height: 18px;
  background: #ffeae8;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &.leftTop {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0px 0px 9px 0px;
    display: flex;
  }
  &.blockTag {
    display: flex;
    margin-bottom: 6px;
  }
  &.multiInlint {
    display: flex;
    margin-left: 6px;
  }
  &.YS {
    background: #ffeae8;
    color: #ec3d2f;
    &::after {
      content: '易生';
    }
  }
  &.QB {
    background: #fff1e8;
    color: #fe6500;
    &::after {
      content: '钱宝';
    }
  }
  &.LS {
    background: #e9f2ff;
    color: #247eff;
    &::after {
      content: '乐刷';
    }
  }
  &.HK {
    background: #e6f2ff;
    color: #49a1ff;
    &::after {
      content: '海科';
    }
  }
  &.DY {
    background: #ecffff;
    color: #0cbabe;
    &::after {
      content: '电银';
    }
  }
}
</style>
